<template>
  <div class="flex flex-wrap -mb-8 -mr-6 p-8">
    <div v-if="$permissions.getPermission(treatment_type, 'type')" class="pr-6 pb-8 w-full lg:w-2/2">
      <select-dropdown
        v-model="form.intervention_type_id" required :options="intervention_types"
        :error="form.errors.intervention_type_id" :label="$t('interventions.intervention_type')"
      />
    </div>
    <div v-if="$permissions.getPermission(treatment_type, 'employee')" class="pr-6 pb-8 w-full lg:w-1/2">
      <select-dropdown
        v-model="form.user_id"
        :options="users"
        :error="form.errors.user_id"
        :label="$t('interventions.user')"
      />
    </div>
    <div v-if="$permissions.getPermission(treatment_type, 'cooperation')" class="pr-6 pb-8 w-full lg:w-1/2">
      <select-dropdown
        v-model="form.cooperation_id"
        required
        :options="cooperations"
        :error="form.errors.cooperation_id"
        :label="$t('interventions.cooperation')"
      />
    </div>
    <text-input
      v-if="$permissions.getPermission(treatment_type, 'date')"
      v-model="form.date"
      required
      :type="'date'"
      :date-not-in-future="true"
      :error="form.errors.date"
      class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('interventions.date')"
    />
    <div v-if="$permissions.getPermission(treatment_type, 'location')" class="pr-6 pb-8 w-full lg:w-1/2">
      <select-dropdown
        v-model="form.location_id"
        required
        :options="locations"
        :error="form.errors.location_id"
        :label="$t('interventions.location')"
      />
    </div>
    <text-input
      v-if="$permissions.getPermission(treatment_type, 'location') && emptyLocationField"
      v-model="form.location_field"
      :error="form.errors.location_field"
      class="pb-8 pr-6 w-full lg:w-1/2"
      :required="requiredLocation"
      :label="$t('interventions.location_specify')"
    />
    <select-multiple
      v-if="$permissions.getPermission(treatment_type, 'request')"
      v-model="form.request_ids"
      required
      :default-options="requests"
      :error="form.errors.request_ids"
      class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('interventions.request')"
    />
    <text-input
      v-if="$permissions.getPermission(treatment_type, 'request') && emptyRequestField"
      v-model="form.request_field"
      :error="form.errors.request_field"
      class="pb-8 pr-6 w-full lg:w-1/2"
      :label="$t('interventions.request_specify')"
    />
    <radio-horizontal
      v-if="$permissions.getPermission(treatment_type, 'send_field')" v-model="form.send_field" :error="form.errors.send_field"
      class="pr-6 pb-8 w-full lg:w-1/3" :options="send_types"
      :required="true"
      :label="$t('interventions.send_type')"
    />
    <radio-horizontal
      v-if="$permissions.getPermission(treatment_type, 'seen')" v-model="form.seen" :error="form.errors.seen"
      class="pr-6 pb-8 w-full lg:w-1/3" :options="seen_types"
      :required="true"
      :label="$t('interventions.seen')"
    />
    <quill-input
      v-model="form.notes" :error="form.errors.notes" class="pb-8 pr-6 w-full lg:w-2/2"
      :label="$t('notes')"
    />
    </div>
</template>
<script>
import TextInput from '@/Shared/TextInput'
import SelectDropdown from '@/Shared/SelectDropdown'
import QuillInput from '@/Shared/QuillInput'
import SelectMultiple from '@/Shared/SelectMultiple'
import find from 'lodash/find'
import intersectionWith from 'lodash/intersectionWith'
import map from 'lodash/map'
import RadioHorizontal from '@/Shared/RadioHorizontal'

export default {
  components: {
    TextInput,
    SelectDropdown,
    QuillInput,
    SelectMultiple,
    RadioHorizontal,
  },
  props: ['formData', 'intervention_types', 'cooperations', 'users', 'locations', 'isNew', 'statuses', 'treatment_type', 'requests', 'send_types', 'seen_types'],
  data() {
    return {
      requiredLocation: false,
    }
  },
  computed: {
    form() {
      return this.formData
    },
    //If location has empty_field (e.g. other), show empty text field
    emptyLocationField() {
      let field = find(this.locations, { id: this.form.location_id })
      if (field) {
        return field.empty_field
      }
      return null

    },
    //If request has empty_field (e.g. other), show empty text field
    emptyRequestField() {
      let content = intersectionWith(this.requests, map(this.form.request_ids, 'id'), (o, id) => o.id === id)
      for (let item of content) {
        if (item.empty_field) {
          return true
        }
      }
      return false
    },
  },
  watch: {
    emptyLocationField(){
      this.setCorrectFields()
    },
  },
  mounted() {
    this.setCorrectFields()
  },
  methods: {
    setCorrectFields() {
      if (this.emptyLocationField) {
        this.requiredLocation = true
      } else {
        this.requiredLocation = false
      }
    },
  },
}
</script>
